import { reactive } from 'vue';

class ErrorLog {
    errors = reactive([]);

    push(level, message) {
        this.errors.push({ level, message, readCount: 0 });
    }

    markAllAsRead() {
        this.errors.forEach((error, index) => {
            this.markAsRead(index);
        });
    }

    markAsRead(index) {
        this.errors[index].readCount += 1;

        if (this.errors[index].readCount >= 2) {
            this.errors.splice(index);
        }
    }
}

export default ErrorLog;
